import { GAME_TYPES } from '@/features/gameSession/store/constants';

export const GAME_QUERY_PARAM = 'game';
export const LANE_CHOOSER_THEME_QUERY_PARAM = 'theme';

export type SupportedGameType = (typeof GAME_TYPES)[keyof typeof GAME_TYPES];

const normalizeGameKey = (value?: string | null) => {
	return value?.trim().toLowerCase().replace(/[_\s]/g, '-') ?? '';
};

export const getGameTypeFromQueryValue = (value?: string | null): SupportedGameType | null => {
	switch (normalizeGameKey(value)) {
		case 'time-game':
		case 'timegame':
		case GAME_TYPES.TIME_GAME.toLowerCase():
			return GAME_TYPES.TIME_GAME;
		case 'lane-chooser':
		case 'lanechooser':
		case 'canoe-game':
		case GAME_TYPES.LANE_CHOOSER_GAME.toLowerCase():
			return GAME_TYPES.LANE_CHOOSER_GAME;
		case 'letter-party':
		case 'letterparty':
		case 'letter-party-game':
		case GAME_TYPES.LETTER_PARTY_GAME.toLowerCase():
			return GAME_TYPES.LETTER_PARTY_GAME;
		default:
			return null;
	}
};

export const getGameTypeFromSearchParams = (searchParams: URLSearchParams): SupportedGameType | null => {
	return getGameTypeFromQueryValue(searchParams.get(GAME_QUERY_PARAM));
};
